import { toast } from "react-toastify";

export const notifyError = (msg: string) =>
  toast(msg, { theme: "colored", position: "bottom-right", type: "error", className: "w-full" });

export const notifyWarn = (msg: string) =>
  toast(msg, { theme: "colored", position: "bottom-right", type: "warning", className: "w-full" });

export const notifySuccess = (msg: string) =>
  toast(msg, { theme: "colored", position: "bottom-right", type: "success", className: "w-full", autoClose: 1000 });

export const notifyErrorPersistent = (msg: string) =>
  toast(msg, {
    theme: "colored",
    position: "bottom-right",
    type: "error",
    className: "w-full",
    autoClose: false,
    closeButton: true,
    closeOnClick: false,
  });

export const notifySuccessPersistent = (msg: string) =>
  toast(msg, {
    theme: "colored",
    position: "bottom-right",
    type: "success",
    className: "w-full",
    autoClose: false,
    closeButton: true,
    closeOnClick: false,
  });
